class SectionHorizontalTextVideo implements ng.IComponentController {
    ltTitle: string;
    description: string;
    video: anm.LandingVideo;
    buttons: anm.LandingButtonData[];
}

angular.module('animatronApp.sectionHorizontalTextVideo', []).component('sectionHorizontalTextVideo', {
    bindings: {
        ltTitle: '<',
        description: '<',
        buttons: '<',
        video: '<',
    },
    controller: SectionHorizontalTextVideo,
    templateUrl: require('landing-template/components/sections/section-horizontal-text-video.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/sections/SectionHorizontalTextVideo.ts